exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flat[data-v-1de3eb78]{box-shadow:none}.rounded[data-v-1de3eb78]{border-radius:40px}.button[data-v-1de3eb78]{font-size:14px;font-weight:700;min-height:54px;height:auto;padding:10px 40px}", ""]);

